<template>
    <div>
        <el-dialog title="发布资源" :visible.sync="$store.state.resourcesDialogState" width="700px" :before-close="beforeClose">
            <el-form :model="resourcesForm"  label-width="110px" ref="resourcesFormRef" :rules="rules">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资源名称" prop="resName">
                            <el-input class="handle-input" v-model="resourcesForm.resName" clearable placeholder="请输入资源名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="CPU核心数" prop="resCPU">
                            <!-- <el-input class="handle-input" v-model="resourcesForm.resCPU" clearable placeholder="请输入CPU核心数">
                                <template #append>
                                    核
                                </template>
                            </el-input> -->
                            <el-select v-model="resourcesForm.resCPU" class="handle-input" filterable placeholder="请选择CPU核心数">
                                <el-option
                                v-for="item in resourcesForm.optionCPU"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="内存容量" prop="resMemory">
                            <!-- <el-input class="handle-input" v-model="resourcesForm.resMemory" clearable placeholder="请输入内存容量">
                                <template #append>
                                    GB
                                </template>
                            </el-input> -->
                            <el-select v-model="resourcesForm.resMemory" class="handle-input" filterable placeholder="请选择内存容量">
                                <el-option
                                v-for="item in resourcesForm.optionMemory"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="硬盘容量" prop="resHard">
                            <!-- <el-input class="handle-input" v-model="resourcesForm.resHard" clearable placeholder="请输入硬盘容量">
                                <template #append>
                                    GB
                                </template>
                            </el-input> -->
                            <el-select v-model="resourcesForm.resHard" class="handle-input" filterable placeholder="请选择硬盘容量">

                                <el-option
                                v-for="item in resourcesForm.optionHard"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="型号" prop="resModel">
                            <!-- <el-input class="handle-input" v-model="resourcesForm.resModel" clearable placeholder="请输入型号"></el-input> -->
                            <el-select v-model="resourcesForm.resModel" class="handle-input" filterable placeholder="请选择型号">
                                <el-option
                                v-for="item in resourcesForm.optionModel"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="卡数" prop="resCardNum">
                            <el-input class="handle-input" v-model="resourcesForm.resCardNum" clearable placeholder="请输入卡数"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12"> 
                        <el-form-item label="组网" prop="resNetworking">
                            <!-- <el-input class="handle-input" v-model="resourcesForm.resNetworking" clearable placeholder="请输入组网"></el-input> -->
                            <el-select v-model="resourcesForm.resNetworking" class="handle-input" filterable placeholder="请选择组网">

                                <el-option label="IB" value="IB"></el-option>
                                <el-option label="Roce" value="Roce"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="台数" prop="resUnitNum">
                            <el-input class="handle-input" v-model="resourcesForm.resUnitNum" clearable placeholder="请输入台数"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <!-- <el-col :span="12">
                        <el-form-item label="可租台数">
                            <el-input class="handle-input" v-model="resourcesForm.resRentableNum" clearable placeholder="请输入可租台数"></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="12">
                        <el-form-item label="可接受付款方式">
                            <el-input class="handle-input" v-model="resourcesForm.resPayWay" clearable placeholder="请输入可接受的付款方式"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="地点" prop="resLocation">
                            <el-select class="handle-input" v-model="resourcesForm.resLocation" clearable placeholder="请选择地点" >
                                <el-option
                                v-for="item in resourcesForm.optionLocation"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资源状态" prop="type">
                            <el-radio-group v-model="resourcesForm.type">
                                <el-radio :label="1">随时可租</el-radio>
                                <el-radio :label="2">指定日期可租</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="resourcesForm.type === 2">
                        <el-form-item label="可租日期" prop="resDate">
                            <el-date-picker
                                class="handle-input"
                                v-model="resourcesForm.resDate"
                                type="date"
                                placeholder="请选择可租日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="月租金额" prop="resMonthPrice">
                            <el-input class="handle-input" v-model="resourcesForm.resMonthPrice" clearable placeholder="请输入月租金额"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="年租金额" prop="resYearPrice">
                            <el-input class="handle-input" v-model="resourcesForm.resYearPrice" clearable placeholder="请输入年租金额"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                <el-form-item label="资源描述" prop="description">
                    <el-input type="textarea" v-model="resourcesForm.description" clearable placeholder="请输入资源描述"></el-input>
                </el-form-item>
                <el-form-item label="备注" >
                    <el-input type="textarea" v-model="resourcesForm.resRemarks" clearable placeholder="请输入备注内容"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="beforeClose">取 消</el-button>
                <el-button type="primary" @click="getSubmitData">提 交</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import {
    releaseResource
} from '@/api/index';
export default {
    // watch: {
    //     '$store.state.demandDialogState': function (newVal) {
    //         console.log(newVal);
    //     },
    // },
    data(){
        return{
            resourcesForm:{
                resName:"",//资源名称
                resCPU:"",//CPU核心数
                optionCPU:[
                    {
                        value: '0',
                        label: '0'
                    },{
                        value: '1',
                        label: '1'
                    },{
                        value: '2',
                        label: '2'
                    },{
                        value: '4',
                        label: '4'
                    },{
                        value: '8',
                        label: '8'
                    },{
                        value: '16',
                        label: '16'
                    },{
                        value: '28',
                        label: '28'
                    },{
                        value: '32',
                        label: '32'
                    },{
                        value: '48',
                        label: '48'
                    }
                ],
                resMemory:"",//内存容量
                optionMemory:[
                    {
                        value: '0',
                        label: '0'
                    },{
                        value: '2GB',
                        label: '2GB'
                    },{
                        value: '4GB',
                        label: '4GB'
                    },{
                        value: '8GB',
                        label: '8GB'
                    },{
                        value: '16GB',
                        label: '16GB'
                    },{
                        value: '32GB',
                        label: '32GB'
                    },{
                        value: '64GB',
                        label: '64GB'
                    }
                ],
                resHard:"",//硬盘容量
                optionHard:[
                    {
                        value: '0',
                        label: '0'
                    },{
                        value: '480GB',
                        label: '480GB'
                    },{
                        value: '500GB',
                        label: '500GB'
                    },{
                        value: '960GB',
                        label: '960GB'
                    },{
                        value: '1024GB',
                        label: '1024GB'
                    },{
                        value: '2048GB',
                        label: '2048GB'
                    },{
                        value: '4096GB',
                        label: '4096GB'
                    },{
                        value: '6000GB',
                        label: '6000GB'
                    }
                ],
                resModel:"",//型号
                optionModel:[
                    {
                        value: 'H800',
                        label: 'H800'
                    },{
                        value: 'H200',
                        label: 'H200'
                    },{
                        value: 'H20',
                        label: 'H20'
                    },{
                        value: 'H100',
                        label: 'H100'
                    },{
                        value: 'A800',
                        label: 'A800'
                    },{
                        value: 'A100',
                        label: 'A100'
                    },{
                        value: '4090',
                        label: '4090'
                    }
                ],
                resCardNum:"",//卡数
                resNetworking:"",//组网
                resUnitNum:"",//台数
                // resRentableNum:"",//可租台数
                resLocation:"",//地点
                optionLocation:[
                    {
                        value: '北京',
                        label: '北京'
                    },{
                        value: '新疆',
                        label: '新疆'
                    },{
                        value: '青海',
                        label: '青海'
                    },{
                        value: '上海',
                        label: '上海'
                    },{
                        value: '广州',
                        label: '广州'
                    },{
                        value: '温州',
                        label: '温州'
                    },{
                        value: '郑州',
                        label: '郑州'
                    },{
                        value: '宁夏',
                        label: '宁夏'
                    },{
                        value: '廊坊',
                        label: '廊坊'
                    },{
                        value: '连云港',
                        label: '连云港'
                    },{
                        value: '金华',
                        label: '金华'
                    },{
                        value: '厦门',
                        label: '厦门'
                    },{
                        value: '江苏',
                        label: '江苏'
                    },{
                        value: '安徽',
                        label: '安徽'
                    },{
                        value: '福州',
                        label: '福州'
                    },
                ],
                type:1,//资源状态
                resDate:"",//可租日期
                resMonthPrice:"",//月租金额
                resYearPrice:"",//年租金额
                resPayWay:"", //可接受付款方式
                // resSource:"",//来源
                // optionSource:[
                //     {
                //         value: '资源采购',
                //         label: '资源采购'
                //     },{
                //         value: '技术支持',
                //         label: '技术支持'
                //     },{
                //         value: '定制开发',
                //         label: '定制开发'
                //     },
                // ],
                description:"卡数,可按需提供。",//资源描述
                resRemarks:"",//备注
            },
            rules:{
                resName: [
                    { required: true, message: '请输入资源名称', trigger: 'blur' }
                ],
                resCPU: [
                    { required: true, message: '请选择CPU核心数', trigger: 'change' }
                ],
                resMemory: [
                    { required: true, message: '请选择内存容量', trigger: 'change' }
                ],
                resHard: [
                    { required: true, message: '请选择硬盘容量', trigger: 'change' },
                    // 输入限制为2进制数值
                    // { pattern: /^[0-1]+$/, message: '请输入2进制数值', trigger: 'blur' }
                ],
                resModel: [
                    { required: true, message: '请选择型号', trigger: 'change' }
                ],
                resCardNum: [
                    { required: true, message: '请输入卡数', trigger: 'blur' }
                ],
                resNetworking: [
                    { required: true, message: '请选择组网', trigger: 'change' }
                ],
                resUnitNum: [
                    { required: true, message: '请输入台数', trigger: 'blur' }
                ],
                resLocation: [
                    { required: true, message: '请选择地点', trigger: 'change' }
                ],
                type: [
                    { required: true, message: '请选择资源状态', trigger: 'change' }
                ],
                resDate: [
                    { required: true, message: '请选择可租日期', trigger: 'change' }
                ],
                // 月租金额和年租金额 至少有一项必填
                // 填了月租金额 可不填年租金额
                // 填了年租金额 可不填月租金额
                

                resMonthPrice: [
                    { validator: this.validateMonthlyOrAnnualRent, trigger: 'blur' }
                ],
                resYearPrice: [
                    { validator: this.validateMonthlyOrAnnualRent, trigger: 'blur' }
                ],
                description: [
                    { required: true, message: '请输入资源描述', trigger: 'blur' }
                ],
            }
        }
    },
    mounted(){
    },
    methods:{
        validateMonthlyOrAnnualRent(rule, value, callback) {
            if (!this.resourcesForm.resMonthPrice && !this.resourcesForm.resYearPrice) {
                callback(new Error('月租金额和年租金额至少填写一项'));
            } else {
                callback();
            }
        },
        getSubmitData(){
            this.$refs['resourcesFormRef'].validate((valid) => {
                if (valid) {
                    this.getSubmitForm();
                } else {
                    console.log('错误!');
                    return false;
                }
            });
        },
        extractNumber(str){
            const match = str.match(/\d+/);
            return match ? parseInt(match[0], 10) : null;
        },
        getSubmitForm(){
            let data = {
                resourceName:this.resourcesForm.resName,//资源名称
                resourceDesc:this.resourcesForm.description,//资源描述
                cpuCore:this.extractNumber(this.resourcesForm.resCPU),//CPU核心数
                memoryCapacity:this.extractNumber(this.resourcesForm.resMemory),//内存容量
                hardDisk:this.extractNumber(this.resourcesForm.resHard),//硬盘容量
                address:this.resourcesForm.resLocation,//地点
                model:this.resourcesForm.resModel,//型号
                cardsNum:this.resourcesForm.resCardNum,//卡数
                networking:this.resourcesForm.resNetworking,//组网
                totalNum:this.resourcesForm.resUnitNum,//台数
                // rentableNum:this.resourcesForm.resRentableNum,//可租台数
                
                rentOn:this.resourcesForm.type,//资源状态
                rentDate:this.resourcesForm.resDate,//可租日期
                monthRent:this.resourcesForm.resMonthPrice,//月租金额
                yearRent:this.resourcesForm.resYearPrice,//年租金额
                // source:this.resourcesForm.resSource,//来源
                payType:this.resourcesForm.resPayWay,//可接受付款方式
                remark:this.resourcesForm.resRemarks,//备注
            }
            console.log(data);
            releaseResource(data).then(res=>{
                // console.log(res);
                if(res.data){
                    this.$message.success('资源发布成功');//提示消息
                    this.$store.commit('SET_RESOURCES_DIALOG_STATE', false); //关闭弹窗
                    // 发布成功后跳转资源-个人中心
                    this.$router.push({path:'/resourceUser'});
                    // 发布成功后跳转资源-个人中心 切换到资源发布tab
                    // this.activeName = 'second';
                    sessionStorage.setItem('activeName','second');
                }else {
                    this.$message.error(res.message);
                }
            })
        },
        beforeClose(){
            this.$refs['resourcesFormRef'].resetFields();
            this.$store.commit('SET_RESOURCES_DIALOG_STATE', false);
        }
    }
    
}
</script>


<style scoped>

.handle-input{
    width:220px;
    margin-right:10px;
}
</style>